(function ($) {
	/**
	 * Nav menu toggle
	 */
	const navLeaveCatch = $('#nav-leave-catch');
	const navToggler = $(".navbar-toggler");
	const header = $('.header');
	const svg = navToggler.find('svg.hamburger-svg');
	const topLine = svg.find('rect').eq(0);
	const midLine = svg.find('rect').eq(1);
	const botLine = svg.find('rect').eq(2);


	const escapeKeyHandler = function(e) {
		if (e.key === 'Escape') {
			toggleMenu();
		}
	};


	let _timers = [];
	const _q = (fn, t) => { _timers.push(setTimeout(fn, t)); };
	const _clear = () => { _timers.forEach(clearTimeout); _timers = []; };

	const animateToX = () => {
		_clear();
		topLine.css({ transform: "translateY(8px)" });
		botLine.css({ transform: "translateY(-8px)" });

		_q(() => { midLine.css({ opacity: 0 }); }, 30);
		_q(() => {
			topLine.css({ transform: "translateY(8px) rotate(45deg)" });
			botLine.css({ transform: "translateY(-8px) rotate(-45deg)" });
		}, 100);
	};

	const animateToMenu = () => {
		_clear();
		topLine.css({ transform: "translateY(8px) rotate(0deg)" });
		botLine.css({ transform: "translateY(-8px) rotate(0deg)" });

		_q(() => { midLine.css({ opacity: 1 }); }, 30);
		_q(() => {
			topLine.css({ transform: "translateY(0) rotate(0)" });
			botLine.css({ transform: "translateY(0) rotate(0)" });
		}, 100);
	};


	const toggleMenu = () => {
		header.add('.hamburger, .newsticker').toggleClass('is-active');
		$('body').toggleClass('no-scroll');
		$('.main-nav').fadeToggle(150);

		const open = header.hasClass('is-active');

		if (open) {
			animateToX();
			navLeaveCatch.attr('tabindex', 0);
			navToggler.attr('aria-expanded', true);
			$(document).on('keydown', escapeKeyHandler);
		} else {
			animateToMenu();
			navLeaveCatch.attr('tabindex', -1);
			navToggler.attr('aria-expanded', false);
			$(document).off('keydown', escapeKeyHandler);
		}
	};


	navToggler.add('.skip-link-menu-toggler').on("click", toggleMenu);

	navLeaveCatch.on("focus click", function () {
		navToggler.focus();
	});


	/*
	 * Mobile Menu
	 */
	function activateMobileMenu() {
		$(".menu-item-has-children > a")
			.off("click.mobileMenu")
			.on("click.mobileMenu", function (e) {
				e.preventDefault();
				const $link = $(this);
				const hasSubmenu = $link.siblings('.sub-menu').length > 0;

				if (hasSubmenu) {
					e.preventDefault();
					e.stopImmediatePropagation();
					// Menü öffnen oder toggeln
				}
				const $parentItem = $(this).parent(".menu-item-has-children");

				// Andere Menüpunkte deaktivieren
				$(".menu-item-has-children").not($parentItem).removeClass("active");
				$(".submenu-toggle").not($parentItem.find(".submenu-toggle")).removeClass("open");

				// Aktuellen Menüpunkt aktivieren
				$parentItem.toggleClass("active");
				$parentItem.find(".submenu-toggle").toggleClass("open");

				$('.menu-item-has-children .menu-item a').on('click', function () {
					$('body').removeClass('no-scroll');
				});

			});
	}

	function deactivateMobileMenu() {
		$(".menu-item-has-children > a").off("click.mobileMenu");
		$(".menu-item-has-children").removeClass("active");
		$(".submenu-toggle").removeClass("open");
	}

	function handleMobileMenu() {
		if (window.matchMedia("(max-width: 768px)").matches) {
			activateMobileMenu();
		} else {
			deactivateMobileMenu();
		}
	}

	handleMobileMenu();
	$(window).on("resize", handleMobileMenu);

	// close nav if the link stays on the same page but the anchor changes
	$('*:not(.has-submenu) > .nav-link').on('click', function() {
		const linkPath = (new URL(this.href)).pathname;
		const urlPath = window.location.pathname;
		if(linkPath === urlPath) {
			toggleMenu();
		}
	});
})(jQuery);
